import { styled } from "@mui/material/styles";

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: "100vh",
});

export const Form = styled("form")({
  margin: "0 16px",
});

export const Row = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

export const CashOutInfo = styled("div")({
  display: "flex",
  flexDirection: "column",
  margin: "22px 16px 16px",
  fontFamily: "FSElliotPro",
  fontSize: "14px",
  fontWeight: "normal",
  lineHeight: 1.5,
  paddingLeft: "2px",
  paddingRight: "16px",
  color: "#616367",
  "& li": {
    listStyle: "none",
    display: "flex",
    gap: "8px",
  },
});
